import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import Checkbox from "./elements/Checkbox"
import Icon from "./elements/Icon"
// 
import { useAppState } from "@nosto/preact"
import { useState, useEffect } from "preact/hooks"

export default function Facet({ facet }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)

    // let { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)
    // let { selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)

    // const [ active, setActive ] = useState(null);

    // console.log('useAppState()', useAppState());
    // console.log('useAppState()?.query?.products', useAppState()?.query?.products);
    // console.log('useAppState()?.query?.products?.filter', useAppState()?.query?.products?.filter);
    // console.log('facet', facet);
    // console.log('useFacet(facet)', useFacet(facet));
    // console.log('facet.field', facet.field);
    // useEffect(() => {
        // const currentFilter = facet.field;
        // let currentlyOpenFilters = []
        // useAppState()?.query?.products?.filter?.forEach(ele => {
        //     currentlyOpenFilters.push(ele.field);
        // });
        // console.log(currentlyOpenFilters, 'currentlyOpenFilters')
        // console.log(currentFilter, 'currentFilter')
        // setActive(currentlyOpenFilters.includes(currentFilter))
        // console.log(active)
    // })


    return (
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`}>
            <a
                // class="ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated ns-p-4"
                class="ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated padding-4-vertical"
                href="javascript:void(0)"
                data-nosto-element="facet"
                onClick={toggleActive}
                // onClick={setActive(!active)}
            >
                <span class="ns-color-black ns-font-4">{facet.name}</span>
                {/* {selectedFiltersCount > 0 && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                        {selectedFiltersCount}
                    </span>
                )} */}
                <Icon name="arrow" className="ns-absolute" />
            </a>
            {/* <div class="ns-sidebar-submenu ns-d-none ns-p-4"> */}
            <div class="ns-sidebar-submenu ns-d-none">
                <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                    {facet.data?.map(value => (
                        <li
                            class="ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3"
                            data-nosto-element="facet-setting"
                        >
                            <Checkbox
                                value={value.value}
                                selected={value.selected}
                                onChange={e => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                            />
                            {/* <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 ns-font-3 ns-font-bold ns-color-black ns-background-grey-light ns-border-radius-3">
                                {value.count}
                            </span> */}
                            <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 ns-font-3 ns-font-bold ns-color-black ns-border-radius-3">
                                ({value.count})
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    )
}
